import React, { Component } from "react"
import "./index.css"
import ListAltIcon from "@material-ui/icons/ListAlt"
import GroupIcon from "@material-ui/icons/Group"
import BarChart from "@material-ui/icons/BarChart"
import MoodIcon from "@material-ui/icons/Mood"
import PhoneIcon from "@material-ui/icons/Phone"
import { BsGraphUpArrow } from "react-icons/bs";
import { BiNetworkChart } from "react-icons/bi";
import { TbActivityHeartbeat } from "react-icons/tb";
import { TbLayoutDashboard } from "react-icons/tb";
import { Link } from 'react-router-dom'
import Timeline from "@material-ui/icons/Timeline"
import { HR_ASSESSMENT_SCORE, HR_EVENTS, HR_OVERVIEW, HR_SESSIONS, HR_SUPPORT, HR_THERAPY, HR_USERS, HR_CHALLENGES, HR_ZEN_ANALYTICS, 
  // HR_Content_Trend
 } from "./HRDashboard"
export class LeftMenu extends Component {

  render() {
    return (
      <div className='left-menustuff'>
        <p className='title-lms'>
          GoodLives<sup>TM</sup>
        </p>
        <div className='content-lms'>
          <ul>
            <li
              className={`${this.props.selectedTab === HR_OVERVIEW ? "active" : ""}`}
              onClick={() => {
                this.props.showOverView()
              }}
            >
              <TbLayoutDashboard className="nav-icon" size={25}/> Overview
            </li>
            <li
              className={`${this.props.selectedTab === HR_USERS ? "active" : ""}`}
              onClick={() => {
                this.props.showUsers()
              }}
            >
              {/* <GroupIcon /> Users */}
              <GroupIcon /> Employee Engagement
            </li>
            <li
              className={`${this.props.selectedTab === HR_THERAPY ? "active" : ""}`}
              onClick={() => {
                this.props.showTherapy()
              }}
            >
              {/* <TbActivityHeartbeat className="nav-icon" size={25}/> Therapy */}
              <TbActivityHeartbeat className="nav-icon" size={25}/> Wellness Insights
            </li>
            {/* <li
              className={`${this.props.selectedTab === HR_Content_Trend ? "active" : ""}`}
              onClick={() => {
                this.props.showContentTrend()
              }}
            >
              <BsGraphUpArrow className="nav-icon" size={20}/> Content Trend
            </li> */}
            <li
              className={`${this.props.selectedTab === HR_SESSIONS ? "active" : ""}`}
              onClick={() => {
                this.props.showSessions()
              }}
            >
              {/* <BarChart /> Sessions */}
              <BarChart /> Content Trend
            </li>
            <li
              className={`${this.props.selectedTab === HR_EVENTS ? "active" : ""}`}
              onClick={() => {
                this.props.showEvents()
              }}
            >
              <BiNetworkChart className="nav-icon" size={25}/> Events
            </li>
            <li
              className={`${this.props.selectedTab === HR_CHALLENGES ? "active" : ""}`}
              onClick={() => {
                this.props.showChallenges()
              }}
            >
              <BsGraphUpArrow className="nav-icon" size={20}/> Challenges
            </li>
            <li
              className={`${this.props.selectedTab === HR_ASSESSMENT_SCORE ? "active" : ""}`}
              onClick={() => {
                this.props.showOrganizational()
              }}
            >
              {/* <MoodIcon /> Assessment Score */}
              {/* <Timeline/> Zen  Analytics */}
            </li>
            {/* <li  className={`${this.props.selectedTab === HR_ZEN_ANALYTICS ? "active" : ""}`}
              onClick={() => {
                this.props.showSlack()
              }}
            > 
            <Timeline/>Zen  Analytics old</li> */}
            {/* <li onClick={() => {
              this.props.showstartchallenge()
              this.setState({
                startchallenge: true,
                organizationalActive: false,
                sessionsActive: false,
                usersActive: false,
                supportActive: false,
                overviewActive: false,
                viewchallenge: false,
                startsurvey: false,
              })
            }}><MoodIcon />Challenge</li> */}

            {/* <li onClick={() => {
              this.props.showmychallenge()
              this.setState({
                startchallenge: false,
                viewchallenge: true,
                organizationalActive: false,
                sessionsActive: false,
                usersActive: false,
                supportActive: false,
                overviewActive: false,
                startsurvey:false,
              })
            }}><MoodIcon />View my Challenge</li> */}

            {/* <li onClick={() => {
              this.props.showstartsurvey()
              this.setState({
                startsurvey:true,
                startchallenge: false,
                organizationalActive: false,
                sessionsActive: false,
                usersActive: false,
                supportActive: false,
                overviewActive: false,
                viewchallenge: false,
              })
            }}><MoodIcon />Survey</li> */}

            {/* <li
              className={`${this.props.selectedTab === HR_SUPPORT ? "active" : ""}`}
              onClick={() => {
                this.props.showSupport()
              }}
            >
              <PhoneIcon /> Support
            </li> */}
          </ul>
        </div>
      </div>
    )
  }
}

export default LeftMenu